<template>
  <div class="home">
    <div class="columns is-multiline is-mobile">
      <div class="column is-4-tablet is-6-mobile is-3-desktop">
        <router-link :to="{
          name: 'eden-samples'
        }">
          <div class="square-icon-box is-danger">
            <div class="icon-box-wrapper">
              <b-icon class="icon-box"
                      icon="x-ray">
              </b-icon>
            </div>
            <div class="box-title">
              Muestras
            </div>
            <div class="box-text">
              Generadas por interfaz
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Index",
  components: { },
  computed: {

  },
  mounted() {//    console.log(this.$store.state.menu.menuApps);
    if (this.$store.state.menu.menuApps) {
      this.$store.commit("toggleMenuApps");
    }
  }
};
</script>

<style scoped>

</style>